import { genericPage, getServerSidePropsHelper } from 'components/3catinfo/Page';
import { useRouter } from 'next/router';
import { usePageEditMode } from 'hooks/usePageEditMode';

const path = ['web', process.env.FOLDER_LAYOUTS_3CATINFO];

const Pagina = (props) => {
    const router = useRouter();
    const genericPageProps = usePageEditMode(props, router);
    return genericPage(genericPageProps, router, path);
};

export async function getServerSideProps(context) {
    return getServerSidePropsHelper(context, { slugs: path });
}

export default Pagina;
